import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../const/api";
import style from "styled-components";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
  AmountButton,
  BlinkingLabel
} from "./DepositElements";
import {
  errorNotification,
  successNotification,
} from "../../utils/toastNotifications";
import { useTranslation } from "react-i18next";
import { formatNumber, toLocale, toLocaleString } from "../../utils/tools";
import { selectCurrency } from "../../features/user/userSlice";
import QR from '../../assets/images/PFQR1.png';
import { useDispatch, useSelector } from 'react-redux';
import { selectQRPagoFacil, setQRPagofacil, selectesperando, setesperando, selectIdTrans  } from '../../features/modals/modalsSlice';
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";

const FormPFqrMercantil = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  auto,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const QRPagoFacil = useSelector(selectQRPagoFacil);
  const EsperandoPago = useSelector(selectesperando);
  const dispatch = useDispatch();
  const [timeLeft, setTimeLeft] = useState(0);
  const transaction_id = useSelector(selectIdTrans);
  const transaccion = transaction_id.toString();
  const [loading2, setLoading2] = useState(false);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const [tiempoExpirado, setTiempoExpirado] = useState(false);
  const [tiempoExpiradoAux, setTiempoExpiradoAux] = useState(false);

  const limitaciones = useSelector(selectLimites);
  const [montoMinimo, setMontoMinimo] = useState(10)
  const [montoMaximo, setMontoMaximo] = useState(10000)

  useEffect(()=>{
    if(limitaciones.minimo_deposito>0 && limitaciones.minimo_deposito>montoMinimo) setMontoMinimo(limitaciones.minimo_deposito)

    if(limitaciones.maximo_deposito>0 && limitaciones.maximo_deposito<montoMaximo) setMontoMaximo(limitaciones.maximo_deposito)
  },[limitaciones])


  // Limpia el estado del QR cuando el componente se desmonte o se cierre el modal
  useEffect(() => {
    return () => {
      dispatch(setQRPagofacil(null));
      setTimeLeft(0);
      handleChange({
        target: {
          name: "monto1",
          value: ""
        }
      });
    };
  }, [dispatch]);

  // Efecto para manejar el temporizador
  useEffect(() => {
    if (!EsperandoPago) {
      setTimeLeft(0);
      return;
    }

    setTimeLeft(900); // Tiempo inicial
    const interval = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime > 0) {
          if (prevTime == 5) {
            setTiempoExpiradoAux(true); // Marca el tiempo como expirado cuando quedan 5 segundos
          }

          if (prevTime <= 1) {
            setTiempoExpirado(true); // Marca el tiempo como expirado
          }
          return prevTime - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [EsperandoPago]);


  useEffect(() => {
    const intervalId = setInterval(() => {
      if (auto && QRPagoFacil && !tiempoExpiradoAux) {
        handleConsulta();
      }
    }, 5000); // 5 segundos

    return () => {
      clearInterval(intervalId);
    };
  }, [auto, QRPagoFacil, tiempoExpiradoAux]);

  useEffect(() => {
    if (auto &&  QRPagoFacil && tiempoExpirado) {
      handleConsultaFinal(); // Llama a la función handleConsulta cuando el tiempo se acaba
    }
  }, [auto, QRPagoFacil, tiempoExpirado]);

  const handleConsulta = async (e) => {
    if (tiempoExpirado) {
      return;
    }
    let body = {
      payment_method: 'QR',
      transaction_id: transaccion,
    };
    
    const res = await axios.post(API_URL + "consultDepositTransaction", body);
    
    const { data } = res;
    const estadoTransaccion = data.response_data?.values?.EstadoTransaccion;

    if (estadoTransaccion !== undefined) {
      switch (estadoTransaccion) {
        case 1:
          errorNotification("Transacción Pendiente", "top-center");
        break;
        case 2:
          successNotification("Transacción Aprobada", "top-center");
          dispatch(setQRPagofacil(null));
          let verificando = {
            title: `INFORMACIÓN`,
            text: "Su pago ha sido acreditado exitosamente, por favor refresque  la página. ",
            allowOutsideClick: true,
            icon: "success",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
        break;
        case 3:
          successNotification("Transacción Revertida", "top-center");
          dispatch(setQRPagofacil(null));
          handleClose();
        break;
        case 4:
          errorNotification("Transacción Anulada", "top-center");
          dispatch(setQRPagofacil(null));
          handleClose();
        break;
      }
    } else {
      if (data.code === 403 && data.message === 'La transacción ya fue procesada') {
        successNotification("Transacción Aprobada", "top-center");
        dispatch(setQRPagofacil(null));
        let verificando = {
          title: `INFORMACIÓN`,
          text: "Su pago ha sido acreditado exitosamente, por favor refresque  la página. ",
          allowOutsideClick: true,
          icon: "success",
          background: SECONDARY,
          color: "#fff",
          showConfirmButton: true,
          confirmButtonColor: PRIMARY,
          confirmButtonText: "Aceptar",
        };
        Swal.fire(verificando);
      } else {
        errorNotification("Ha ocurrido un error, por favor intente de nuevo", "top-center");
        dispatch(setQRPagofacil(null));
      }
    }
  };

  const handleConsultaFinal = async () => {
    await handleConsulta();
    let body = {
      transaction_id: transaccion,
    };
    const res = await axios.post(API_URL + "cancelDepositTransaction", body);
    if (res.data.code === 200) {
      errorNotification(res.data.message, "top-center");
      dispatch(setQRPagofacil(null));
      
    } else {
      errorNotification(
        "Ha ocurrido un error, por favor intente de nuevo",
        "top-center"
      );
     dispatch(setQRPagofacil(null));
    }
  };

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  const changeAmount = (valor) => {
    handleMonto({target: {value: valor, name: 'monto1'}});
  }

  return (
    <Form className={'pagofacil'}>
    {QRPagoFacil && (
      <InputContainer>
       <BlinkingLabel>{EsperandoPago}: {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</BlinkingLabel>
      </InputContainer>
    )}
    <InputContainer>
      <label>{t("deposit.lbl-amount")}</label>
      </InputContainer>
      <AmountButton>
        <Button onClick={()=>{changeAmount('20,00')}}>20 BOB</Button>
        <Button onClick={()=>{changeAmount('50,00')}}>50 BOB</Button>
        <Button onClick={()=>{changeAmount('100,00')}}>100 BOB</Button>
        <Button onClick={()=>{changeAmount('200,00')}}>200 BOB</Button>
      </AmountButton>

      <InputContainer>
        <input
          type="text"
          placeholder="0,00"
          name="monto1"
          value={form.monto1}
          onChange={(e) => handleMonto(e)}
        />

        {monto < montoMinimo && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {toLocaleString(montoMinimo)} {moneda}{" "}
          </ErrorSpan>
        )}
        {monto > montoMaximo && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {toLocaleString(montoMaximo)} {moneda}{" "}
          </ErrorSpan>
        )}


        {/* {monto < 10 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 10 {moneda}{" "}
          </ErrorSpan>
        )}
        {monto > 10000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 10.000 {moneda}{" "}
          </ErrorSpan>
        )} */}
      </InputContainer>
      {QRPagoFacil && (
        <img src={`data:image/png;base64,${QRPagoFacil}`} className={'qrpagofacilotro'} alt="QR Code" style={{width:'80%', marginTop:'40px', marginLeft: '33.5px', marginBottom:'-120px'}} />
      )}
      <ButtonsContainer style={{marginTop:'120px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
            dispatch(setQRPagofacil(null));
          }}
        >
          {t("deposit.btn-back")}
        </Button>
          <Button
            primary={true}
            disabled={loading || monto < montoMinimo || monto > montoMaximo || QRPagoFacil}
            onClick={handleSubmit}
          >
            {loading ? t("deposit.QR") : t("deposit.btn-QR")}
          </Button>
      </ButtonsContainer>
    </Form>
  );
};

export default FormPFqrMercantil;
